import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Headers from "../components/common/header";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
  ApplicationInsights,
  ITelemetryPlugin,
} from "@microsoft/applicationinsights-web";
import { INSTRUMENTATION_KEY } from "../config/config";
import UserForm from "./user-form";

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: INSTRUMENTATION_KEY,
    disableFetchTracking: false,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin as unknown as ITelemetryPlugin],
    autoTrackPageVisitTime: true,
  },
});
appInsights.loadAppInsights();
const Router = () => {

  return (
    <BrowserRouter>
      <Headers />
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/form" />}
        />
        <Route path="/form" element={<UserForm />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
